<template>
  <div class="page-home">
    <div class="inLogo">
      <img v-if="logo" :src="logo" alt="logo" class="logo">
    </div>
    <div class="container">
      <img :src="bgImg" alt="" class="bg">
      <LogOut/>
      <div class="content">
        <div class="ml15">
          <img :src="titleImg" class="title" alt="">
          <!-- <div class="line"/> -->
          <!-- <div class="text">国际一流的汽车数字化运营服务提供商，共建设美好车生活</div> -->
        </div>
        <van-grid :gutter="0" :border="false" :column-num="2" class="card-wrapper" v-if="roleMessage !=='301' && roleMessage !=='401'">
          <van-grid-item>
            <div class="card new-car" @click="toRealName('RnrPersonCard', 0, 0)">
              <div class="card-text1">新车车主</div>
              <div class="card-text2">针对未实名或者已解除的车辆</div>
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="card new-car-consigner" @click="toRealName('RnrPersonCard', 0, 1)">
              <div class="card-text1">新车代办</div>
              <div class="card-text2">车主无法到现场，委托他人代办</div>
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="card used-car" @click="toRealName('RnrPersonCard', 1, 0)">
              <div class="card-text1">二手车新车主</div>
              <div class="card-text2">针对未解除的车辆</div>
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="card used-car-consigner" @click="toRealName('RnrPersonCard', 1, 1)">
              <div class="card-text1">二手车代办</div>
              <div class="card-text2">车主无法到现场，委托他人代办</div>
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="card enterprise" @click="toRouterPage('RnrEnterpriseCard')">
              <div class="card-text1">企业实名认证</div>
              <div class="card-text2">针对未实名或者已解除的企业车辆</div>
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="card car-search" @click="toRouterPage('RnrCarSearch')">
              <div class="card-text1">单车认证查询</div>
              <div class="card-text2">查询单台车辆认证信息</div>
            </div>
          </van-grid-item>
        </van-grid>
        <van-dialog
          v-model="showPermissionDialog"
          show-confirm-button
          confirm-button-color="#FFFFFF"
          @confirm="goBack"
        >
          <p><span>——————</span> 提示<span>——————</span></p>
          <p>无访问权限</p>
        </van-dialog>
      </div>
    </div>
    <van-overlay :show="loading">
      <van-loading size="40px" vertical>加载中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LogOut from '@/components/LogOut'
import { Toast } from 'vant'
import { RESET_PERSON, RESET_ENTERPRISE, DISPATCH_INIT_PROTOCAL, SET_PERSON_CONSIGNER } from '@/store/modules/rnr'
import { thirdAuthUrl } from '@/api/loginToB.js'
import { getRoleMessage } from '@/api/rnr.js'
import { Dialog } from 'vant'

export default {
  name: 'Home',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    LogOut
  },
  data() {
    return {
      loading: false,
      bgImg: require('@/assets/images/bg.png'),
      titleImg: require('@/assets/images/title.png'),
      roleMessage: '',
      showPermissionDialog: false
    }
  },
  computed: {
    ...mapGetters(['logo'])
  },
  async created() {
    // 如果当前在钉钉浏览器中打开
    if (window.os.isDingTalk) {
      Toast('请勿在钉钉内打开实名系统')
    }
    this.$store.dispatch(`rnr/${DISPATCH_INIT_PROTOCAL}`)
    // 请求logo
    await this.$store.dispatch('dict/getLogo', {
      isCustomer: false,
      force: true,
      tenantNo: this.$store.getters.loginUser.tenantNo
    })
  },
  beforeMount() {
    getRoleMessage().then(res => {
      this.roleMessage = res.msg
      if (this.roleMessage === '301' || this.roleMessage === '401') {
        this.showPermissionDialog = true
      }
    })
  },
  methods: {
    goBack() {
      const source = localStorage.getItem('source')
      if (source === 'H5' || source === 'CIAM') {
        localStorage.removeItem('source')
        console.log('home.vue')
        thirdAuthUrl({ target: source === 'CIAM' ? 'ciam' : 'auth', type: 'LOGOUT' }).then(url => { window.location = url })
        return
      }
    },
    /**
     * 是否有协议
     */
    notHasProtocal() {
      // =======测试环境修改-begin-=======
      // 直接返回已经没有协议需要签署
      // ======修改前:
      return !this.$store.getters.protocal || !this.$store.getters.protocal.realnameNoticeVertical
      // ======修改后:
      // return false
      // =======测试环境修改-end-=======
    },

    /**
     * 校验协议是否存在
     */
    async verifyProtocalExist() {
      // 如果当前没有上传协议，则再查一遍协议
      if (this.notHasProtocal()) {
        // 展示loading框
        this.loading = true
        try {
          await this.$store.dispatch(`rnr/${DISPATCH_INIT_PROTOCAL}`)
        } catch (error) {
          console.error(error)
        }
        // 关闭loading框
        this.loading = false
        // 查询一遍后依然没有协议，则不让继续
        if (this.notHasProtocal()) {
          Toast('请补齐协议文件')
          return false
        }
      }
      return true
    },

    /**
     * 跳转到实名页面
     * @param routerName 路由名称
     * @param customerType 客户类型 0：新车车主 1：二手车车主
     * @param isConsigner 是否委托人代办 1：是 0：否
     */
    async toRealName(routerName, customerType, isConsigner) {
      // 校验文件是否存在
      const isProtocalExist = await this.verifyProtocalExist()
      // 如果当前没有上传协议，则再查一遍协议
      if (!isProtocalExist) {
        return
      }
      // 清空store中保存的个人,企业实名数据
      this.$store.commit(`rnr/${RESET_PERSON}`)
      this.$store.commit(`rnr/${RESET_ENTERPRISE}`)
      // 设置客户类型和是否委托人代办
      this.$store.commit(`rnr/${SET_PERSON_CONSIGNER}`, {
        customerType,
        isConsigner: isConsigner === 1
      })
      // 如果当前是自然人实名认证
      this.$router.push({
        name: routerName,
        query: {
          customerType,
          isConsigner
        }
      })
    },

    /**
     * 跳转到路由页面
     * @param routerName 路由名称
     */
    async toRouterPage(routerName) {
      // 校验文件是否存在
      const isProtocalExist = await this.verifyProtocalExist()
      // 如果当前没有上传协议，则再查一遍协议
      if (!isProtocalExist) {
        return
      }
      this.$router.push({ name: routerName })
    }
  }
}
</script>

<style lang="scss">
.van-dialog{
  border-radius: 10px;
  height: 300px;
  padding: 30px 0;
  .van-button{
    background: #000;
    border-radius: 60px;
    max-width: 500px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  p{
    text-align: center;
    padding: 6px 0;
    span{
      color: #EEEEEE;
    }
  }
}
.RoleMessage{
  width: 80%;
  height: 200px;
  border: 1px solid;
  display: flex;
  align-items: center;
  margin: auto;
  margin-top: 300px;
  text-align: center;
}
.inLogo{
 display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    height: 123px;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 20px 0 38px;
    background-color: #242424;
    .logo {
    width:312px;
    margin-top: -2px;
    display: inline-block;
    }
}
.page-home {
  background: url(../../assets/images/bg_home.png) 0 0 no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  .van-overlay {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .container {
    position: relative;
    padding: 0 24px;
    .bg {
      position: absolute;
      top: -30px;
      right: 0;
      width: 468px;
      height: 664px;
    }
    .content {
      padding-top: 56px;
      position: relative;
      z-index: 1;
      .logo {
        width: auto;
        height: 48px;
      }
      .title {
        margin-top: 1.66667rem;
        width: 4.026667rem;
        height: 0.936667rem;
        display: block;
      }
      .line {
        width: 163px;
        height: 3px;
        margin: 38px 0 36px;
        background-image: linear-gradient(90deg, #2C38D2 0%, #61A2F9 50%, #fff 100%);

      }
      .text {
        width: 380px;
        font-size: 26px;
        line-height: 36px;
        color: #596B97;
        font-weight: 400;
        margin-bottom: 126px;
      }
      .card-wrapper {
        margin-top: 1.666667rem;
        .van-grid-item {
          overflow: hidden;
          .van-grid-item__content {
            background-color: transparent;
            padding: 0px;
          }
        }
        .card {
          background-size: auto 100%;
          background-repeat: no-repeat;
          background-position: center center;
          box-sizing: border-box;
          width: 352px;
          height: 256px;
          padding-top: 50px;
          padding-left: 46px;
          padding: 50px 42px 0 44px;
          .card-text1 {
            font-family: PingFangSC-Semibold;
            font-size: 32px;
            line-height: 44px;
            color: #FFFFFF;
            text-shadow: 0 2px 7px rgba(48,89,197,0.70);
            font-weight: 600;
            margin-bottom: 8px;
          }
          .card-text2 {
            width: 246px;
            opacity: 0.83;
            font-family: PingFangSC-Regular;
            font-size: 20px;
            line-height: 28px;
            color: #FFFFFF;
            font-weight: 400;
          }
          &.new-car {
            background-image: url(../../assets/home/ico_new_car.png);
          }
          &.new-car-consigner {
            background-image: url(../../assets/home/ico_new_car-consigner.png);
          }
          &.used-car {
            background-image: url(../../assets/home/ico_used_car.png);
          }
          &.used-car-consigner {
            background-image: url(../../assets/home/ico_used_car-consigner.png);
          }
          &.enterprise {
            background-image: url(../../assets/home/ico_enterprise.png);
          }
          &.car-search {
            background-image: url(../../assets/home/ico_car_search.png);
          }
        }
      }
      .ml15 {
        margin-left: 33px;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue